/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { string, shape, arrayOf, bool, func } from "prop-types";
import { transactionStatus } from "pages/transactions/constants";
import GridTable from "pages/_components/GridTable/GridTable";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import Button from "pages/_components/Button";
import { TransactionSign } from "pages/_components/TransactionCard";
import * as i18n from "util/i18n";
import EcheqMultipleHeaderTicket from "pages/echeck/components/EcheqMultipleHeaderTicket";
import CustomData from "../../../_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import { Spring, config } from "react-spring";
import InfoTag from "pages/echeck/components/InfoTag";
import { isFinishedWithErrors } from "../../utils"
import FormattedAmount from "pages/_components/FormattedAmount";

const EndorseTransactionMultipleBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {}, idTransactionStatus } = transaction;
    const { showMoreData, setShowMoreData, isCancelEndorse } = props;
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const isPending = idTransactionStatus === transactionStatus.PENDING;

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    const { isDesktop } = props;
    let {
        beneficiary,
        beneficiaryName,
        reference,
        referencevalue,
        echeqList,
        endorsements,
    } = data;

    if (!data.endorsements)
         endorsements = data.echeqList.map((  { cheque_id, monto } ) => ({ cheque_id, monto }));

    reference = reference != "" ? reference : "-";
    referencevalue = referencevalue != "" ? referencevalue : "-";

    const getAmoutTotal = () => {
        let total = 0;
        echeqList.forEach((echeq) => {
            total += parseFloat(echeq.monto);
        });
        return total;
    };

    const getCurrency = () => {
        return echeqList[0].moneda;
    }

    const getCharacter = () => {
        return echeqList[0].cheque_caracter;
    }

    const getCancelReason = () => {
        return transaction?.data.specialAttribute;
    }

    const getStatusTag = (cheque_is, endorsements) => {
        if (idTransactionStatus == "PENDING")
            return "warning";
        if (idTransactionStatus == "CANCELLED")
            return "error";

        const state = endorsements.find((endorsement) => endorsement.cheque_id === cheque_is)?.error;

        switch (state) {
            case "success":
                return "success";
            case "error":
                return "error";
            default:
                return "success";
        }
    };

    const getStatus = (cheque_is, endorsements) => {
        let state = endorsements.find((endorsement) => endorsement.cheque_id === cheque_is)?.error;
        switch (idTransactionStatus) {
            case "PENDING":
                state = "pending";
                break;
            case "CANCELLED":
                state = "cancelled";
                break;
        }
        return `echeqs.endorsement.status.${state || "success"}`;
    };

    return (
        <div className="ticket__body echeq-endorse">
            <>
                <EcheqMultipleHeaderTicket
                    moneda={getCurrency()}
                    monto={getAmoutTotal()}
                    status={isFinishedWithErrors(transaction?.data?.endorsements) ? "FINISHED_WITH_ERRORS" : idTransactionStatus}
                    isDesktop={isDesktop}
                />
                <div className="view-more-data-button">
                    <div className="ticket__divider inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                    <Button
                        aria-expanded={showMoreData ? "true" : "false"}
                        className="more-button"
                        label={buttonLabel}
                        bsStyle="link"
                        onClick={handleSeeMoreData}
                        image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                    />
                </div>
                <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                    <div className="ticket-section">
                        <div
                            style={{
                                display: "block",
                                width: "100%",
                                gridColumn: "1 / -1",
                            }}>
                            <GridTable>
                                <GridTable.Container className="ticket-gap">
                                    {!isCancelEndorse && (
                                    <>
                                    <GridTable.Data columnStart={1} rowStart={1}>
                                        <CustomData
                                            titleText="echecks.beneficiary"
                                            titleTextType="I18N"
                                            valueText={beneficiaryName}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={1}>
                                        <CustomData
                                            titleText="echecks.document"
                                            titleTextType="I18N"
                                            valueText={beneficiary}
                                        />
                                    </GridTable.Data>

                                    <GridTable.Data columnStart={1} rowStart={2}>
                                        <CustomData
                                            titleText="echecks.echeckReference"
                                            titleTextType="I18N"
                                            valueText={reference}
                                            valueTextType="TEXT"
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={2}>
                                        <CustomData
                                            titleText="echecks.echeckReferenceValue"
                                            titleTextType="I18N"
                                            valueText={referencevalue}
                                            valueTextType="TEXT"
                                        />
                                    </GridTable.Data>
                                    </>
                                    )}
                                    <GridTable.Data columnStart={1} rowStart={3}>
                                        <CustomData
                                            titleText="echecks.echeckNature"
                                            titleTextType="I18N"
                                            valueText={getCharacter()}
                                            valueTextType="TEXT"
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={3}>
                                        <CustomData 
                                            titleText="echecks.currency" 
                                            titleTextType="I18N" 
                                            valueText={getCurrency()}
                                        />
                                    </GridTable.Data>


                                    <GridTable.Data columnStart={1} rowStart={4}>
                                        <CustomData
                                            titleText="echecks.quantity.echeqs"
                                            titleTextType="I18N"
                                            valueText={echeqList.length}
                                            valueTextType="TEXT"
                                        />
                                    </GridTable.Data>

                                    <GridTable.Data columnStart={2} rowStart={4}>
                                        <CustomData
                                            titleText="echecks.monto.total"
                                            titleTextType="I18N"
                                            valueText={getAmoutTotal()}
                                            valueTextType={getCurrency()}
                                        />
                                    </GridTable.Data>

                                    {isCancelEndorse && (
                                        <GridTable.Data columnStart={1} rowStart={5}>
                                            <CustomData
                                                titleText="echecks.cancelEndorse.reason"
                                                titleTextType="I18N"
                                                valueText={getCancelReason()}
                                            />
                                        </GridTable.Data>
                                    )}

                                </GridTable.Container>
                            </GridTable>
                        </div>
                        <div className="ticket__divider divider_2 inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <div
                            style={{
                                display: "block",
                                width: "100%",
                                gridColumn: "1 / -1",
                            }}>
                            <GridTable>
                                {isDesktop && (
                                    <GridTable.Container className="three-cols" columns={3} rows={1}>
                                        <GridTable.Data columnWidth={1} columnStart={1} rowStart={1}>
                                            <CustomText
                                                className="title-discounts"
                                                text={""}
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data columnWidth={1} columnStart={2} rowStart={1}>
                                            <CustomText
                                                className="title-discounts font-bold"
                                                text={i18n.get("echecks.status")}
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data columnWidth={1} columnStart={3} rowStart={1} alignX="center">
                                            <CustomText
                                                className="title-discounts font-bold"
                                                text={i18n.get("echecks.table.amount")}
                                            />
                                        </GridTable.Data>
                                    </GridTable.Container>
                                )}
                                <Spring
                                    config={config.stiff}
                                    from={{ height: 0 }}
                                    to={{
                                        height: echeqList.length ? "auto" : 0,
                                        overflow: "hidden",
                                    }}>
                                    {(styles) => (
                                        <div className="form-group" style={styles}>
                                            <div className="form-group-control-list">
                                                {echeqList.map((echeq, index) => (
                                                    <GridTable.Container
                                                        className="three-cols"
                                                        columns={3}
                                                        rows={1}
                                                        key={index}>
                                                        <GridTable.Data columnWidth={1} columnStart={1} rowStart={1}>
                                                            {isDesktop ? (
                                                                <CustomText text={`Echeq ${echeq.cheque_numero}`} />
                                                            ) : (
                                                                <CustomData
                                                                    titleText="detail.discounts.echek.id"
                                                                    titleTextType="I18N"
                                                                    valueText={`Echeq ${echeq.cheque_numero}`}
                                                                />
                                                            )}
                                                        </GridTable.Data>
                                                        <GridTable.Data columnWidth={1} columnStart={2} rowStart={1}>
                                                            <InfoTag
                                                                type="info"
                                                                message={i18n.get(
                                                                    getStatus(echeq.cheque_id, endorsements)
                                                                )}
                                                                tagBackground={getStatusTag(
                                                                    echeq.cheque_id, endorsements,
                                                                )}
                                                            />
                                                        </GridTable.Data>
                                                        <GridTable.Data columnWidth={1} columnStart={3} rowStart={1} alignX="center">
                                                            {isDesktop ? (
                                                                <CustomText
                                                                    text={<FormattedAmount currency={echeq.moneda} quantity={echeq.monto} />}
                                                                    textType="TEXT"
                                                                />
                                                            ) : (
                                                                <CustomData
                                                                    titleText="echecks.table.amount"
                                                                    titleTextType="I18N"
                                                                    valueText={<FormattedAmount currency={echeq.moneda} quantity={echeq.monto} />}
                                                                    textType="TEXT"
                                                                />
                                                            )}
                                                        </GridTable.Data>
                                                        {index !== echeqList.length - 1 && !isDesktop && (
                                                            <div className="ticket__divider inside-ticket__body">
                                                                <div className="ticket__notch ticket__notch--left" />
                                                                <div className="ticket__notch ticket__notch--right" />
                                                            </div>
                                                        )}
                                                    </GridTable.Container>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </Spring>
                            </GridTable>
                        </div>
                        <TransactionSign
                            isSmall
                            creationTime
                            hasVaucher
                            isDesktop={isDesktop}
                            noDate={isPending}
                            showMoreData={showMoreData}
                        />
                    </div>
                </div>
            </>
        </div>
    );
};

EndorseTransactionMultipleBody.propTypes = {
    beneficiary: shape({
        reference: string,
        document: string,
    }),
    echeqList: arrayOf(echeqPropTypes),
    address: string,
    referencevalue: string,
    reference: string,
    isDesktop: bool.isRequired,
    showMoreData: bool,
    setShowMoreData: func,
};

EndorseTransactionMultipleBody.defaultProps = {
    beneficiary: {
        reference: "",
        document: "",
    },
    echeqList: [],
    address: "",
    referencevalue: "",
    reference: "-",
    showMoreData: false,
    setShowMoreData: () => {},
};

export default EndorseTransactionMultipleBody;